import { Icon } from '@/design-system/components/icons/Icon';
import { TextCaption, TextTitle } from '@/design-system/components/typography';
import { Pressable, SxProp, useDripsyTheme, View } from 'dripsy';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCenterLink } from '../../enum';
import { openURL } from '../../utils/utils';

export interface HelpCenterComponentProps {
  sx?: SxProp;
}

export const HelpCenterComponent: React.FC<HelpCenterComponentProps> = ({ sx }) => {
  const { t } = useTranslation('global-bill-payment');
  const { theme } = useDripsyTheme();
  const { $5 } = theme.space || ({} as any);
  const { container, body, item, textItem } = sxStyles;
  const questions = [
    {
      title: t('global-bill-payment::payment-instruction.text--what-type-of-payment-service'),
      url: HelpCenterLink.TYPE_OF_BILL_COVERAGE
    },
    {
      title: t('global-bill-payment::payment-instruction.text--can-I-pay'),
      url: HelpCenterLink.PAY_FOR_OTHER
    },
    {
      title: t('global-bill-payment::payment-instruction.text--holiday-non-working'),
      url: HelpCenterLink.TRANSFER_NONE_WORKING_DAY
    },
    {
      title: t('global-bill-payment::payment-instruction.text--multiple-payment'),
      url: HelpCenterLink.REQUEST_MUlTIPLE_BILL
    }
  ];

  return (
    <View sx={{ ...container, ...sx }}>
      <View sx={body}>
        <TextTitle semiBold={true}>{t('global-bill-payment::help-center.title--help-center')}</TextTitle>
        {questions.map((question, index) => {
          return (
            <Pressable onPress={() => openURL(question.url)} key={index.toString()}>
              <View sx={item}>
                <View sx={{ width: $5, height: $5 }}>
                  <Icon name="letter2" width={$5} height={$5} />
                </View>
                <TextCaption sx={textItem}>{question.title}</TextCaption>
              </View>
            </Pressable>
          );
        })}
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    backgroundColor: 'transparent'
  },
  body: {
    flexDirection: 'column'
  },
  item: {
    flexDirection: 'row',
    mt: '$3',
    alignItems: 'center'
  },
  textItem: {
    ml: '$1',
    color: '$hyperlink'
  }
};
